const trackingBuilder = (items = []) => ({
	appId: 'fb722156-80f5-4807-873c-740cfb737fda',
	itemsAccepted: items.count,
	itemsReceived: items.count,
	errors: []
});

export default trackingBuilder;
